import type {
  AnalyticsCmsDashboard,
  AnalyticsDashboard,
  AnalyticsGuidesDashboard,
  AnalyticsOverviewDashboard,
  AnalyticsPowersDashboard,
  AnalyticsSearchDashboard,
  AnalyticsTrafficDashboard,
  AnalyticsUsersDashboard,
} from '@/types/analytics/dashboard';
import { apiGet } from '@/services/api-client';

async function getSection<T>(path: string): Promise<T | null> {
  try {
    const res = await apiGet<{ data: T }>(path, true);
    return res.data ?? null;
  } catch {
    return null;
  }
}

/** Alias legado — overview consolidado. */
export async function getAnalyticsDashboard(): Promise<AnalyticsDashboard | null> {
  return getSection<AnalyticsDashboard>('/admin/analytics');
}

export async function getOverviewDashboard(): Promise<AnalyticsOverviewDashboard | null> {
  return getSection<AnalyticsOverviewDashboard>('/admin/analytics/overview');
}

export async function getTrafficDashboard(): Promise<AnalyticsTrafficDashboard | null> {
  return getSection<AnalyticsTrafficDashboard>('/admin/analytics/traffic');
}

export async function getSearchDashboard(): Promise<AnalyticsSearchDashboard | null> {
  return getSection<AnalyticsSearchDashboard>('/admin/analytics/search');
}

export async function getGuidesDashboard(): Promise<AnalyticsGuidesDashboard | null> {
  return getSection<AnalyticsGuidesDashboard>('/admin/analytics/guides');
}

export async function getPowersDashboard(): Promise<AnalyticsPowersDashboard | null> {
  return getSection<AnalyticsPowersDashboard>('/admin/analytics/powers');
}

export async function getCmsDashboard(): Promise<AnalyticsCmsDashboard | null> {
  return getSection<AnalyticsCmsDashboard>('/admin/analytics/cms');
}

export async function getUsersDashboard(): Promise<AnalyticsUsersDashboard | null> {
  return getSection<AnalyticsUsersDashboard>('/admin/analytics/users');
}
